import { render, staticRenderFns } from "./demo_user.vue?vue&type=template&id=106b5402&scoped=true&"
import script from "./demo_user.vue?vue&type=script&lang=js&"
export * from "./demo_user.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106b5402",
  null
  
)

export default component.exports